import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterLink } from '@angular/router';
import { UserAuthService } from '../../services/user-auth.service';
import { ApiService } from '../../services/api.service';
import { AuthenticatedUser } from '../../models/client-user.model';

@Component({
  selector: 'app-user-welcome',
  standalone: true,
  imports: [CommonModule, RouterLink],
  templateUrl: './user-welcome.component.html',
  styleUrls: ['./user-welcome.component.scss']
})
export class UserWelcomeComponent implements OnInit {
  user: AuthenticatedUser | null = null;

  constructor(
    private authService: UserAuthService,
    private apiService: ApiService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.user = this.authService.getCurrentUser();
    if (!this.user) {
      this.router.navigate(['/login']);
    }
  }

  onLogout(): void {
    this.apiService.userLogout().subscribe({
      next:  () => { this.authService.clearLocalState(); this.router.navigate(['/login']); },
      error: () => { this.authService.clearLocalState(); this.router.navigate(['/login']); }
    });
  }

  get displayName(): string {
    if (this.user?.firstName || this.user?.lastName) {
      return [this.user.firstName, this.user.lastName].filter(Boolean).join(' ');
    }
    return this.user?.email || 'User';
  }
}

